export const BYTES_IN_KILOBYTE = 1024
